<template>
  <div class="">
    <b-modal
      hide-header
      hide-footer
      id="modal_iframe_share"
      dialog-class="modal-dialog-centered"
      content-class="--ifram-share"
      size="lg"
    >
      <template #default="{ hide }">
        <div class="header mb-4">
          <span class="fs-xl-24px fs-md-20px fs-18px">{{
            $t("appContent.integrate_gallery")
          }}</span>
          <img
            @click="hide()"
            class="close"
            :src="require('@/assets/img/closeModal.svg')"
          />
        </div>
        <div
          class="options d-flex align-items-center justify-content-between mb-4"
        >
          <select id="cases-select" v-model="cases">
            <option value="">{{ $t("appContent.allCases") }}</option>
            <option
              v-for="(provider, i) in players"
              :key="i"
              :value="provider.url"
            >
              {{ provider.name }}
            </option>
          </select>
        </div>
        <div class="capture mb-4">
          <div class="capture-img" v-html="iframeHtml(cases, true)"></div>
        </div>
        <div class="footer d-flex justify-content-between">
          <input type="text" class="input-iframe" :value="iframeHtml(cases)" />
          <div class="position-relative">
            <button
              @click="copy"
              class="btn btn-primary btn-copy"
              @mouseleave="messgae = false"
            >
              {{ $t("appContent.copy") }}
            </button>
            <div v-show="messgae" class="tooltip">
              <span class="tooltiptext">{{
                $t("modal.text_copied_successfully")
              }}</span>
            </div>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>


<script>
import utils from "@/mixins/utils";
import { kebabCase } from "lodash";

export default {
  name: "IframModal",
  data() {
    return {
      header: true,
      cases: "",
      iframe: "",
      messgae: false,
      show: false,
    };
  },
  mixins: [utils],
  computed: {
    allCases() {
      return this.$store.state.players.all.map((e) => {
        return e.name;
      });
    },
    players() {
      return this.$store.state.players.all;
    },
  },
  methods: {
    kebabCase,
    iframeHtml(link, header = null) {
      let mylink = window.location.href;
      let displayHeader = header ? false : this.header;
      mylink += `${link}?header=${displayHeader}&footer=false`;
      return (
        '<iframe src="' +
        mylink +
        '" width="800" height="500" style="border:none" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>'
      );
    },
    copy() {
      let text = this.iframeHtml(this.cases);
      try {
        this.messgae = navigator.clipboard.writeText(text) ? true : false;
      } catch (err) {
        this.messgae = false;
      }
    },
  },
};
</script>

<style lang="scss">
.--ifram-share {
  background-color: black;
  color: white;

  .tooltip {
    top: -1rem;
    left: 50%;
    opacity: 1;
    .tooltiptext {
      visibility: visible;
      width: fit-content;
      background-color: var(--app-color-red);
      color: #fff;
      text-align: center;
      border-radius: 6px;
      padding: 8px 6px;
      position: absolute;
      z-index: 1;
      bottom: 150%;
      left: 50%;
      margin-left: -86px;
      opacity: 1;
      transition: opacity 0.3s;
      white-space: nowrap;
      &:after {
        content: "";
        position: absolute;
        top: 100%;
        left: 50%;
        margin-left: -5px;
        border-width: 5px;
        border-style: solid;
        border-color: var(--app-color-red) transparent transparent transparent;
      }
    }
  }

  .close {
    color: white;
    opacity: 1;
    cursor: pointer;
    &:hover {
      color: white;
    }
    &:focus {
      outline: none;
    }
  }
  .capture {
    width: 100%;
    height: 50vh;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .capture-img {
    width: 100%;
    height: 50vh;

    iframe {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
      border-radius: 0.3rem;
    }
  }
  .modal-body {
    padding: 2rem;
  }
  #cases-select {
    background: transparent;
    color: white;
    padding: 0.75rem 1.25rem;
    border-radius: 0.3rem;
    option {
      color: black;
    }
  }
  .input-iframe {
    padding: 0.5rem 1rem;
    width: 100%;
    background: #1d1d1d;
    border: none;
    border-radius: 0.3rem;
    color: white;
    margin-right: 2rem;
  }
  .btn.btn-copy {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .check-header {
    background-color: transparent;
    border: 1px solid white;
    height: 1.5rem;
    width: 1.5rem;
    -webkit-appearance: none;
    -moz-appearance: none;
    -o-appearance: none;
    appearance: none;
    border-radius: 4px;
    outline: none;
    transition-duration: 0.3s;
    cursor: pointer;
  }

  input.check-header:checked {
    background-color: var(--app-color-red);
    border: 1px solid var(--app-color-red);
    border: none;
    &:after {
      content: "\2713";
      color: white;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  @media (max-width: 720px) {
    .modal-body {
      padding: 1rem;
    }
  }
}
</style>
